<!-- 新闻的后台管理 -->
<template>
  <div class="news">
    <el-form :inline="true" :model="newsQuery">
      <el-form-item>
        <el-input
          placeholder="请输入新闻标题"
          width="100"
          v-model="newsQuery.title"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="newsQuery.categoryId"
          width="100"
          clearable
          placeholder="新闻栏目"
        >
          <el-option
            v-for="item in categories"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item> </el-form-item>
      <el-form-item>
        <el-select
          v-model="newsQuery.showStatus"
          width="100"
          clearable
          placeholder="显示状态"
        >
          <el-option
            v-for="item in categoriesd"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="newsQuery.checkStatus"
          width="100"
          clearable
          placeholder="审核状态"
        >
          <el-option
            v-for="item in categoriesdd"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="newsQuery.startTime"
          type="date"
          width="60"
          placeholder="开始时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="newsQuery.endTime"
          type="date"
          width="100"
          placeholder="结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getNewsList()">查询</el-button>
        <el-button @click="addOrUpdateHandle()">新增</el-button>
        <el-button
          type="danger"
          :disabled="selectDelete.length <= 0"
          @click="multipleDelete()"
          >批量删除
        </el-button>

        <!-- <el-button
          type="success"
          :disabled="sortList.length <= 0"
          @click="multipleUpdate()"
          >保存排序</el-button
        >-->
        <el-button type="warning" @click="chongzhi">重置 </el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="newsList"
      style="width: 100%"
      border
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="index" width="50" label="#" align="center">
      </el-table-column>
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column
        label="标题"
        min-width="100"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            @click="showProduct(scope.row.content)"
            style="color: #409eff; cursor: pointer"
            >{{ showcontent(scope.row.title) }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="新闻描述"
        align="center"
        width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ showcontent(scope.row.description) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
                prop="thumb_"
                label="新闻图片"
                align="center"
                width="130"
            >
                <template slot-scope="scope">
                    <div class="img-show">
                        <el-image
                            v-if="scope.row.thumb != null"
                            width="75%"
                            contain
                            class="image-slot"
                            :src="scope.row.thumb"
                            :preview-src-list="[scope.row.thumb]"
                            fit="contain"
                        ></el-image>
                        <div v-else slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </div>
                </template>
            </el-table-column> -->

      <el-table-column
        prop="categoryId"
        label="新闻类别"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="activityId"
        label="附件链接"
        align="center"
        width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <!-- <span v-html="getActivitiesName(scope.row.activityId)"></span> -->
          <span>{{ scope.row.enclosure }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="origin"
        label="新闻来源"
        align="center"
        width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ showcontent(scope.row.origin) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="新闻内容"
        align="center"
        width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-popover placement="right" width="400" trigger="click">
            <span v-html="showcontent(scope.row.content)"></span>
            <el-button slot="reference">内容详情</el-button>
          </el-popover>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="showStatus"
        label="显示状态"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <el-button
            size="small"
            :type="scope.row.showStatus === '屏蔽' ? 'danger' : 'success'"
            class="padding-style"
            @click="changeShow(scope.row)"
            plain
          >
            {{ scope.row.showStatus }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="checkStatus"
        label="审核状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            class="padding-style"
            :type="checkStyle(scope.row.checkStatus + '')"
            disable-transitions
            @click="examineStatus(scope.row)"
          >
            {{ checkShow(scope.row.checkStatus + "") }}
          </el-button>
        </template>
      </el-table-column>

      <!-- <el-table-column
        prop="createTime"
        label="创建时间"
        width="110"
        align="center"
      >
      </el-table-column>

      <el-table-column
        align="center"
        prop="updateTime"
        label="更新时间"
        width="110"
      >
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="releaseTime"
        label="发布时间"
        width="110"
      >
      </el-table-column>
      <!-- <el-table-column label="置顶" align="center" width="70"> -->
      <!-- <template slot-scope="scope">
                    <el-input
                        align="center"
                        v-model="scope.row.sort"
                        @blur="sortChange(scope.row)"
                    ></el-input>
                </template> -->
      <!-- <template slot-scope="scope">
          <el-button
            size="small"
            :type="scope.row.sort === '置顶' ? 'danger' : 'success'"
            class="padding-style"
            @click="changeShow1(scope.row)"
            plain
          >
            {{ scope.row.sort}}
          </el-button>
        </template>
      </el-table-column> -->

      <el-table-column label="置顶" align="center" width="80">
        <template slot-scope="scope">
          <el-button
            size="size"
            disable-transitions
            class="padding-style"
            type="primary"
            plain
            @click="changeShow1(scope.row)"
          >
            {{ scope.row.sort === 0 ? "不置顶" : "置顶" }}
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="addOrUpdateHandle(scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id, scope.row.title)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @newsUpdateList="newsUpdateList"
    ></add-or-update>
    <!-- 审核新添加列表的弹框 -->
    <check-status
      :check-query="checkQuery"
      ref="checkRef"
      @updateComputed="getNewsList()"
    />
    <el-pagination
      background
      layout="total,prev, pager, next"
      :total="totalCount"
      :page-size="10"
      @current-change="pageChange"
    >
    </el-pagination>
    <!-- 商品内容详情 -->
    <el-dialog
      title="新闻内容"
      :visible.sync="dialogVisible"
      width="50%"
      custom-class="product-dialog"
    >
      <div v-html="showcontent(content)"></div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import AddOrUpdate from "@/views/modules/config/child-components/news-add-or-update";
import CheckStatus from "@/views/modules/config/child-components/check-status";
// 引入转义函数
import { showcontent } from "@/utils/method.js";
import { checkMixin } from "@/utils/mixin.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    AddOrUpdate,
    CheckStatus,
  },
  mixins: [checkMixin],
  data() {
    //这里存放数据
    return {
      activitiesQuery: {
        limit: 10,
        page: 1,
        checkStatus: "",
      },
      newsList: [], // 存放获取到的新闻数组
      selectDelete: [], // 批量删除数组
      sortList: [], // 修改的排序集合
      addOrUpdateVisible: false,

      newsQuery: {
        limit: 10,
        page: 1,
      }, // 存放筛选条件
      categories: [],
      categoriesd: [
        {
          id: 1,
          name: "显示",
        },
        {
          id: 0,
          name: "不显示",
        },
      ],
      categoriesdd: [
        {
          id: 1,
          name: "通过",
        },
        {
          id: 0,
          name: "不通过",
        },
      ],
      totalCount: 0,
      // 审核状态参数
      checkQuery: {
        id: null,
        checkStatus: "1",
        title: "",
      },
      loading: false,
      // activityObj:{},//活动赛事对象
      activitiesList: [],
      content: "",
      dialogVisible: false,
    };
  },

  activated() {
    this.getNewsList();
    this.getCategories();
    this.getActivitiesList();
  },
  methods: {
    //重置
    chongzhi() {
      this.newsQuery = {
        endTime: "",
        startTime: "",
        checkStatus: "",
        showStatus: "",
        categoryId: "",
        title: "",
      };
      this.$nextTick(() => {
        this.getNewsList();
      });
    },
    showcontent,
    // 点击商品内容按钮时显示弹框
    showProduct(content) {
      this.content = content;
      this.dialogVisible = true;
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },

    // 排序输入框失去焦点事件
    sortChange(data) {
      console.log("失去焦点：", data);
      this.sortList.push({
        id: data.id,
        sort: Number(data.sort),
        title: data.title,
      });
    },
    getActivitiesName(id) {
      const activityObj = this.activitiesList.find((item) => {
        return item.id == id;
      });
      // console.log(this.activityObj,22222)
      return activityObj && activityObj.name;
    },

    // 批量修改
    multipleUpdate() {
      console.log(this.sortList);
      this.$http({
        url: this.$http.adornUrl("/news/updateBatch"),
        method: "post",
        data: this.$http.adornData(this.sortList, false),
      }).then(({ data }) => {
        if (data.code === 0) {
          this.sortList = [];
          this.$message.success("批量更新成功!");
        }
      });
    },
    //获取赛事活动名称列表
    getActivitiesList(id) {
      console.log(id, "id");
      // this.loading = true;
      this.$ajaxPost("/activities/listsys/open", this.activitiesQuery).then(
        ({ data }) => {
          console.log(data, "活动赛事");
          if (data.code === 0) {
            // this.activitiesList = data.data;
            // this.loading = false;
            this.activitiesList = data.data.records;
            console.log(this.activitiesList, 1234);
          }
        }
      );
    },

    // 通过 id 删除新闻
    deleteHandle(id, title) {
      this.$confirm("确定要删除该新闻吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl("/news/delete"),
            method: "post",
            data: this.$http.adornData({ id, title }, false),
          }).then(({ data }) => {
            if (data.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getNewsList();
              this.selectDelete = [];
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 处理复选框选择的数据，把所有数据保存到 selectDelete 数组中
    // val 就是所有复选框选择的数组
    handleSelectionChange(val) {
      this.selectDelete = val;
    },

    multipleDelete() {
      let ids = [];
      // 处理请求数据
      for (let i = 0; i < this.selectDelete.length; i++) {
        ids.push(this.selectDelete[i].id);
      }

      console.log("批量删除数据的ids: ", ids);

      this.$confirm("确定要批量删除新闻数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("/news/deleteBatch"),
          method: "post",
          data: this.$http.adornData(ids, false),
        })
          .then(({ data }) => {
            if (data.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getNewsList();
              this.selectDelete = [];
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "删除失败，请联系管理员",
            });
          });
      });
    },
    pageChange(currPage) {
      this.newsQuery.page = currPage;
      this.getNewsList();
    },

    getCategories() {
      this.$http({
        url: this.$http.adornUrl("/category/list/EC000103"),
        method: "get",
        params: this.$http.adornParams({}),
      }).then(({ data }) => {
        console.log("新闻栏目：", data.data);
        this.categories = data.data;
      });
    },

    getNewsList() {
      this.loading = true;
      this.$http({
        url: this.$http.adornUrl("/news/list"),
        method: "post",
        data: this.$http.adornData(this.newsQuery),
      }).then(({ data }) => {
        this.newsList = data.data.list;
        console.log("=========查询结果：", data.data);
        this.totalCount = data.data.totalCount;
        for (let i = 0; i < this.newsList.length; i++) {
          if (this.newsList[i].createTime) {
            this.newsList[i].createTime = this.newsList[i].createTime.substring(
              0,
              10
            );
          }
          if (this.newsList[i].updateTime) {
            this.newsList[i].updateTime = this.newsList[i].updateTime.substring(
              0,
              10
            );
          }
          if (this.newsList[i].releaseTime) {
            this.newsList[i].releaseTime = this.newsList[
              i
            ].releaseTime.substring(0, 10);
          }

          if (this.newsList[i].categoryId == 1001) {
            this.newsList[i].categoryId = "新闻动态";
          } else if (this.newsList[i].categoryId == 1002) {
            this.newsList[i].categoryId = "政策发布";
          } else if (this.newsList[i].categoryId == 1003) {
            this.newsList[i].categoryId = "通知公告";
          } else if (this.newsList[i].categoryId == 1004) {
            this.newsList[i].categoryId = "研究报告";
          } else if (this.newsList[i].categoryId == 1005) {
            this.newsList[i].categoryId = "法律法规";
          } else if (this.newsList[i].categoryId == 1007) {
            this.newsList[i].categoryId = "企业纾困";
          } else if (this.newsList[i].categoryId == 1008) {
            this.newsList[i].categoryId = "活动赛事";
          } else if (this.newsList[i].categoryId == 1009) {
            this.newsList[i].categoryId = "协会动态";
          } else if (this.newsList[i].categoryId == 1010) {
            this.newsList[i].categoryId = "协会通知";
          }
          if (this.newsList[i].showStatus == "1") {
            this.newsList[i].showStatus = "显示";
          } else {
            this.newsList[i].showStatus = "屏蔽";
          }

          if (this.newsList[i].sort == "1") {
            this.newsList[i].sort = "置顶";
          } else {
            this.newsList[i].sort = "";
          }
        }
        this.loading = false;
        this.newsQuery.page = 1;
      });
    },

    // 添加新闻或更新新闻后从新获取新闻列表
    newsUpdateList() {
      this.getNewsList();
    },
    // 审核新闻列表数据
    examineStatus(item) {
      // debugger
      // this.checkQuery.id = item.id
      // this.checkQuery.checkStatus = item.checkStatus
      Object.keys(this.checkQuery).forEach((key) => {
        if (key !== "checkStatus") {
          this.checkQuery[key] = item[key];
        } else {
          if (item[key] == 0) {
            this.checkQuery.checkStatus = "1";
          } else {
            this.checkQuery.checkStatus = item[key].toString();
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.checkRef.init("/news/update");
      });
    },
    // 改变显示状态
    changeShow(item) {
      let { id, showStatus } = item;
      showStatus = showStatus === "显示" ? "0" : "1";
      this.$ajaxPost("/news/update", { id, showStatus }).then(({ data }) => {
        if (data.code === 0) {
          this.getNewsList();
        }
      });
    },
    // 改变显示状态
    changeShow1(item) {
      console.log(item);
      // let categroyId =
      let { id, sort, categoryId } = item;
      sort = sort === "置顶" ? "0" : "1";
      this.$ajaxGet("/news/top", { id, sort, categoryName: categoryId }).then(
        ({ data }) => {
          if (data.code === 0) {
            this.getNewsList();
          } else {
            this.$message({ message: data.msg, type: "error" });
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
/* 日期选择框的宽度 */
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
